import { render } from "./Altar.vue?vue&type=template&id=f4cc58c2&scoped=true"
import script from "./Altar.vue?vue&type=script&lang=js"
export * from "./Altar.vue?vue&type=script&lang=js"

import "./Altar.vue?vue&type=style&index=0&id=f4cc58c2&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4cc58c2"]])

export default __exports__